import {
  START_CREATE_NEW_PLAYLIST,
  FINISH_CREATE_NEW_PLAYLIST,
  SET_PLAYLIST_ORDER,
  START_FETCH_PLAYLISTS,
  FETCH_PLAYLISTS_SUCCESS,
  SET_DISPLAYED_PLAYLIST,
  START_FETCH_PLAYLIST_ENTRIES,
  FETCH_PLAYLIST_ENTRIES_SUCCESS,
  SET_DISPLAYED_PLAYLIST_ENTRIES_ORDER,
  CLEAR_PLAYLIST_ENTRIES
} from '../../actions/playlists'

const defaultState = {
  order: '',
  page: 1,
  playlistEntriesPage: 1,
  creatingPlaylist: false,
  loadingEntries: true
}

let playlists = (state = defaultState, action) => {
  switch (action.type) {
    case START_CREATE_NEW_PLAYLIST:
      return {
        ...state,
        creatingPlaylist: true
      }
    case FINISH_CREATE_NEW_PLAYLIST:
      return {
        ...state,
        creatingPlaylist: false
      }
    case SET_PLAYLIST_ORDER:
      return {
        ...state,
        order: action.order
      }
    case START_FETCH_PLAYLISTS:
      const page = action.reloadAll ? 1 : state.page + 1

      return {
        ...state,
        loading: true,
        reloadingAll: action.reloadAll,
        page
      }
    case FETCH_PLAYLISTS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        total: action.total,
        reloadingAll: false
      })
    case SET_DISPLAYED_PLAYLIST:
      return {
        ...state,
        displayedPlaylistUUID: action.playlist.uuid
      }
    case START_FETCH_PLAYLIST_ENTRIES:
      return Object.assign({}, state, {
        loadingEntries: true
      })
    case CLEAR_PLAYLIST_ENTRIES:
      return Object.assign({}, state, {
        initialPlaylistEntryLoad: true,
        playlistEntriesPage: 1
      })
    case FETCH_PLAYLIST_ENTRIES_SUCCESS:
      const playlistEntriesPage = state.playlistEntriesPage + 1
      return Object.assign({}, state, {
        loadingEntries: false,
        playlistEntriesPage,
        initialPlaylistEntryLoad: false
      })
    case SET_DISPLAYED_PLAYLIST_ENTRIES_ORDER:
      return {
        ...state,
        entriesOrder: action.orderObj
      }
    default:
      return state
  }
}

export default playlists
